import React from "react";
import PropTypes from "prop-types";

const Hint = ({ hintText, children }) => {
    return (
        <div className="hint_container">
            <div className="hint_popup">{hintText}</div>
            {children}
        </div>
    );
};

Hint.propTypes = {
    hintText: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export default Hint;
